module.exports = __webpack_public_path__ + "img/cp-ai-1.225b4d88.png";